import { Injectable, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { BehaviorSubject, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { urlConfig } from '../shared/constants/url-config';

import { HttpService } from '../shared/services/http.service';

@Injectable({
  providedIn: 'root'
})


export class SurveyApiService {

  updatesurveylist: Array<any> = [];
  updatesurveyelement: any;
  imagedata = new BehaviorSubject<any>(null);
  image = this.imagedata.asObservable();
  questionList = new BehaviorSubject<any>(null);
  questions = this.questionList.asObservable();
  dataSaved$: Subject<any> = new Subject<any>();


  constructor(private httpService: HttpService) {
    this.updatesurveyelement = {};
  }

  getCommentCardCustomization(Id: any) {
    return this.httpService.get(urlConfig.getCommentCardCustomization + "?restaurantId=" + Id);
  }

  getFeedbackSurveyQuestions(propertyUniqueName: string, languageId: number) {
    return this.httpService.get(urlConfig.getsurveyurl + "?propertyUniqueName=" + propertyUniqueName + "&languageId=" + languageId);

  }

  getTokens(Token: string) {
    return this.httpService.get(`${urlConfig.getByToken}?token=${Token}&alltype=${true}&options=${325}`);
  }
  getTokensForCommentCard(Token: string, languageId: number) {
    return this.httpService.get(`${urlConfig.getByTokenForCommentCard}?token=${Token}&alltype=${true}&options=${325}&languageId=${languageId}`);
  }
  setImage(data: any) {
    this.imagedata.next(data);
  }

  setQuestion(data: any) {
    this.questionList.next(data);
  }

  getImage(Id: any) {
    return this.httpService.get(urlConfig.layoutseatingImageUrl + Id, true);
  }

  getaddress(restaurentName: string) {
    return this.httpService.get(urlConfig.getWidgetSettings + "?restaurantName=" + restaurentName);
  }

  questionspost(data: any, address: any) {
    console.log('questionpost', data)

    this.updatesurveylist = [];
    this.updatesurveyelement = {};
    data.forEach((element: any) => {

      this.updatesurveyelement = {};
      //this.updatesurveyelement.FeedbackId=element.FeedbackId;
      this.updatesurveyelement.propertyId = element.PropertyID;
      this.updatesurveyelement.PartyId = address.Payload.Id;
      this.updatesurveyelement.FeedbackQuestionId = element.Id;
      this.updatesurveyelement.contactId = address.currentGuest?.ContactId || address.Payload.Contact.Id;
      this.updatesurveyelement.bookingId = element.bookingId;
      this.updatesurveyelement.rating = element.rating;
      this.updatesurveyelement.GuestComments = element.value;
      this.updatesurveyelement.StatusCode = element.StatusCode;
      this.updatesurveylist.push(this.updatesurveyelement);
    });
    console.log("updatesurveylist", this.updatesurveylist);

    //return data;

    return this.httpService.post(urlConfig.updatesurveyurl + '?restaurantId=' + address.Payload.RestaurantId, this.updatesurveylist);


  }



  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}


export const questions = [
  {
    question: 'Any question phrased by admin will be displayed here?',
    type: 'rating',
    options: [
      { value: 1, label: 'Bad' },
      { value: 2, label: 'Ok' },
      { value: 3, label: 'Good' },
      { value: 4, label: 'Very Good' },
      { value: 5, label: 'Excellent' }
    ],
    value: 0
  },
  {
    question: 'Any question phrased by admin will be displayed here?',
    type: 'rating',
    options: [
      { value: 1, label: 'Bad' },
      { value: 2, label: 'Ok' },
      { value: 3, label: 'Good' },
      { value: 4, label: 'Very Good' },
      { value: 5, label: 'Excellent' }
    ],
    value: 0
  },
  {
    question: 'Any question phrased by admin will be displayed here?',
    type: 'rating',
    options: [
      { value: 1, label: 'Bad' },
      { value: 2, label: 'Ok' },
      { value: 3, label: 'Good' },
      { value: 4, label: 'Very Good' },
      { value: 5, label: 'Excellent' }
    ],
    value: 0
  },
  {
    question: 'Any question phrased by admin will be displayed here?',
    type: 'rating',
    options: [
      { value: 1, label: 'Bad' },
      { value: 2, label: 'Ok' },
      { value: 3, label: 'Good' },
      { value: 4, label: 'Very Good' },
      { value: 5, label: 'Excellent' }
    ],
    value: 0
  },
  {
    question: 'Any question phrased by admin will be displayed here?',
    type: 'rating',
    options: [
      { value: 1, label: 'Bad' },
      { value: 2, label: 'Ok' },
      { value: 3, label: 'Good' },
      { value: 4, label: 'Very Good' },
      { value: 5, label: 'Excellent' }
    ],
    value: 0
  },
  {
    question: 'Any Suggestion',
    type: 'text',
    value: ''
  }
];
